import SelectPublisher from '../elements/SelectPublisher'
import { useCampaignForm } from '../hooks/useCampaignForm'
import CampaignStrategy from './CampaignStrategy'

const FormByStrategy: React.FC = () => {
  const { isPublisherContextResolved } = useCampaignForm()

  return (
    <section id="create-campaign-form">
      <SelectPublisher />

      {isPublisherContextResolved && <CampaignStrategy />}
    </section>
  )
}

export default FormByStrategy
